// extracted by mini-css-extract-plugin
export default {"import_types":"ImportType_import_types__nDNy2","spin":"ImportType_spin__RTn-D"};